export function getProductTypeColor(type) {
  switch (type) {
    case 'VIRTUAL_DISPATCHER':
      return '#2db7f5';
    default:
      return 'orange';
  }
}
